import util from '../util'

let controller = 'BloqueioContaLote'

export default {
  CarregarArquivo: function (dto) {
    return util.Axios.PostForm(controller + '/CarregarArquivo', dto)
  },
  BuscarArquivos: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/BuscarArquivos', dto)
  },
  BuscarLinhasErro: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/BuscarLinhasErro', dto)
  }
}
